import { ArrowDown, ArrowRight, ColorSAP } from "../../ontego-ui";
import { styled } from "@mui/material";
import { LogoLight } from "../../assets/img/logo/logoLight";
import Typography from "../../ontego-ui/components/Typography";

const Styled = {};

Styled.NavbarShoppingCartIconContainer = styled("div")(() => ({
  position: "relative",
  "& svg": {
    width: 24,
    height: 24,
    marginRight: 24,
    color: ColorSAP.neutral[0],
    cursor: "pointer",
  },
}));

Styled.NavbarCollectionSizeIndicator = styled("div")(() => ({
  position: "absolute",
  top: -3,
  right: 20,
  height: 16,
  background: ColorSAP.secondary[30],
  borderRadius: 32,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

Styled.NavbarContainer = styled("div")(() => ({
  position: "fixed",
  width: "100%",
  top: 0,
  zIndex: 1300,
}));

Styled.Navbar = styled("div")(() => ({
  width: "100vw",
  height: 64,
  background: ColorSAP.primary[70],
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

Styled.NavbarChildWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  alignItems: "center",
  [theme.breakpoints.between("1280", "1440")]: {
    maxWidth: 1200,
  },
  [theme.breakpoints.up("1440")]: {
    maxWidth: 1200,
  },
}));

Styled.NavbarLogoContainer = styled("div")(() => ({
  marginRight: 100,
}));

Styled.NavbarLogo = styled(LogoLight)(() => ({
  width: `79px !important`,
  height: `32px !important`,
  cursor: "pointer",
  display: "flex"
}));

Styled.NavbarMenuContainer = styled("div")(() => ({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end"
}));

Styled.HoverNavMenuContainer = styled("div")(() => ({
  display: "flex",
  transition: "0.2s",
  "&:hover .subNavContainer": {
    visibility: "visible",
    opacity: 1,
  },
  "&:hover .arrowDown": {
    transform: "rotate(180deg)",
    transition: "0.15s all linear",
  },
}));

Styled.MenuNavContainer = styled("div")(() => ({
  width: "fit-content",
  height: 64,
  userSelect: "none",
  color: ColorSAP.neutral[0],
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  position: "relative",
  "&::after": {
    content: '""',
    position: "absolute",
    bottom: 15,
    left: 0,
    width: 0,
    height: 1,
    backgroundColor: "white",
    transition: "width 600ms ease",
  },
  "&:hover::after": {
    width: "100%",
    left: 0,
  },
}));

Styled.SubNavContainer = styled("div")(() => ({
  display: "flex",
  position: "absolute",
  left: 0,
  width: "100%",
  top: "100%",
  zIndex: 1300,
  background: `linear-gradient(179deg, #000 -375.58%, #3B3FEA 98.98%)`,
  visibility: "hidden",
  opacity: 0,
  transition: "visibility 0s, opacity 0.3s linear",
  paddingTop: 80,
  paddingBottom: 80,
  boxSizing: "border-box",
}));

Styled.RessSubNavLeftContainer = styled(Typography)(() => ({
  paddingTop: 10,
  paddingBottom: 10,
}));

Styled.RessSubNavSeparator = styled("div")(() => ({
  marginLeft: 80,
}));

Styled.SubNavItemContainer = styled("div")(() => ({
  height: 116,
  padding: 16,
  boxSizing: "border-box",
  display: "flex",
  width: '100%',
  alignItems: "flex-start",
  cursor: "pointer",
  transition: "0.2s background-color",
  borderRadius: 12,
  "&:hover": {
    backgroundColor: ColorSAP.primary[80],
  },
}));

Styled.SubNavItemContainer450 = styled(Styled.SubNavItemContainer)(() => ({
  width: 450,
}));

Styled.SubNavText = styled("div")(() => ({
  flexGrow: 2,
  userSelect: "none",
}));

Styled.RessSubNavRightContainer = styled(Styled.RessSubNavSeparator)(() => ({
  marginLeft: 100,
  paddingLeft: 100,
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  borderLeft: `1px solid ${ColorSAP.neutral[0]}`,
  userSelect: "none",
}));

Styled.ArrowHover = styled("div")(() => ({
  marginTop: 40,
}));

Styled.ArrowRightHidden = styled(ArrowRight)(() => ({
  width: "auto",
  paddingLeft: 10,
  position: "absolute",
}));

Styled.ArrowDownIcon = styled(ArrowDown)(() => ({
  marginLeft: 4,
  opacity: 1,
  visibility: "visible",
  transition: "0.15s all linear",
}));

Styled.NavbarChildContainer = styled("div")(() => ({
  height: "100%",
  display: "inline-flex",
  alignItems: "center",
  flexGrow: 1,
  justifyContent: "flex-end",
}));

Styled.SubNavIcon = styled("div")(() => ({
  "& svg": {
    width: `80px !important`,
    height: `80px !important`,
    flexGrow: 1,
    marginRight: 24,
    color: ColorSAP.primary[30],
    color: ColorSAP.primary[30],
  },
}));

export default Styled;
